import { ReactElement, useRef } from 'react';

import {
  Typography,
  Icon,
  Popover,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import styles from './styles.module.scss';

export function WidgetHelp({ help }: { help: string }): ReactElement {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <Popover
      popoverClassName={styles.popover}
      content={
        <Typography className={styles.tooltip} variant='caption'>
          {help}
        </Typography>
      }
    >
      <div className={styles.iconWrapper} ref={ref}>
        <Icon size='medium' iconName={Icons.InfoCircled} />
      </div>
    </Popover>
  );
}
